import { LinkedContainerActionsCell } from '@Components/Cells';
import { type ApiOrder } from '@Model';
import { type Column } from '@synqo/frontend-component-library';

/** The container actions of an order, one line per action and container type. */
export const containerActionsColumn: Readonly<Column<ApiOrder>> = {
    name: 'container_actions',
    label: 'Container',
    renderCell: ({ rowData }) => <LinkedContainerActionsCell containerActions={rowData.container_actions} />,
    disableColumnSort: true,
    disableColumnFilter: true,
};
